import { verifyCookie } from './verify-cookies';
import jwt_decode from 'jwt-decode';
import { Buffer } from 'buffer';



export async function setJWT( params ) {
  if ( typeof params !== 'object' ) {
    throw new Error( 'invalid JWT request' );
  }
  const response = await fetch( `${process.env.REACT_APP_API_BASE_URI}degnon/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  } );
  const responseData = await response.json();
  return responseData;
}

export async function validateOauthToken( code ) {
  if ( !code ) {
    return {};
  }

  const authCookie = verifyCookie( 'auth_code' );
  if ( !authCookie ) {
    return {};
  }

  const jwToken = await jwt_decode( authCookie );

  const response = await fetch( `${process.env.REACT_APP_NEON_BASE_URI}oauth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: new URLSearchParams( {
      'client_id': jwToken.neonOauthId,
      'client_secret': jwToken.neonOauthSecret,
      'redirect_uri': `${process.env.REACT_APP_URL}`,
      'grant_type': 'authorization_code',
      'code': code
    } )
  } );

  const responseData = await response.json();
  return responseData;
}

export async function getMembershipStatus( params ) {
  /* TODO: UTILIZE THE CODE IN GETCONTACTS FROM LAPSED MEMBERS TO FIND ACCOUNT INFO */
  const { apiKey, client, accountId } = params;
  const authToken = 'Basic ' + new Buffer.from( client + ':' + apiKey ).toString( 'base64' );
  const response = await fetch( `${process.env.REACT_APP_API_BASE_URI}neon/accounts/${accountId}/memberships`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': authToken
    }
  } );
  if ( !response.ok ) {
    return null;
  }
  const responseData = await response.json();
  return responseData;
}

export async function getApplications( params ) {
  console.log(params.year);
  const response = await fetch( `${process.env.REACT_APP_API_BASE_URI}apa/rapid/applicants${params.year && '&year=2022'}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  } );
  if ( !response.ok ) {
    return null;
  }
  const responseData = await response.json();
  return responseData;
}

export async function getApplicationSingle( params ) {
  // NEED TO GET THE APPLICATIONS FROM THE /v1/apa/rapid/applicants endpoint
  if ( !params.id ) {
    return null;
  }
  const response = await fetch( `${process.env.REACT_APP_API_BASE_URI}apa/rapid/applicants/${params.id}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  } );
  if ( !response.ok ) {
    return null;
  }
  const responseData = await response.json();
  return responseData;
}

export async function getGrades ( params ) {
  if ( !params.revId ) {
    return null;
  }
  const response = await fetch( `${process.env.REACT_APP_API_BASE_URI}apa/rapid/grades/${params.revId}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if ( !response.ok ) {
    return null;
  }
  const responseData = await response.json();
  return responseData;
}

export async function newApplication( params ) {

  if ( typeof params !== 'object' ) {
    return new Error( 'malformed form data' );
  }

  // TODO: We must sanitize out any single quotes before going forward w this


  const response = await fetch( `${process.env.REACT_APP_API_BASE_URI}apa/rapid/applicants`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  } );
  if ( !response.ok ) {
    return null;
  }
  const responseData = await response.json();
  return responseData;
}

export async function newReview( params ) {
  if ( typeof params !== 'object' ) {
    return new Error( 'malformed form data' );
  }
  const response = await fetch( `${process.env.REACT_APP_API_BASE_URI}apa/rapid/grades`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  } );
  if ( !response.ok ) {
    return null;
  }
  const responseData = await response.json();
  return responseData;
}

export async function reviewerLogin( params ) {
  if ( typeof params !== 'object' ) {
    return new Error( 'malformed form data' );
  }
  const response = await fetch( `${process.env.REACT_APP_API_BASE_URI}apa/rapid/reviewer/auth`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  } );
  if ( !response.ok ) {
    return null;
  }
  const responseData = await response.json();
  return responseData;
}

export async function getNeonKeys( params ) {
  const { apiKey } = params;
  
  const response = await fetch( `${process.env.REACT_APP_API_BASE_URI}apa/rapid/token`, {
    headers: {
      'Content-Type': 'application/json',
      'api-key': apiKey
    }
  });

  if ( !response.ok ) {
    throw new Error('fetch error');
  }

  const responseData = await response.json();
  return responseData;
}

export async function getAwsKeys( params ) {
  const { apiKey } = params;
  
  const response = await fetch( `${process.env.REACT_APP_API_BASE_URI}apa/rapid/awsToken`, {
    headers: {
      'Content-Type': 'application/json',
      'api-key': apiKey
    }
  });

  if ( !response.ok ) {
    throw new Error('fetch error');
  }

  const responseData = await response.json();
  return responseData;
}